mutation editMarketSplit($id: String!, $column: String!, $value: String!) {
    editMarketSplit(id: $id, column: $column, value: $value)
}
